<template>
    <div class="col-12 mb-3 mb-lg-2 p-lg-2 p-md-1 mb-md-2">
        <div class="card">
            <div class="border-tile-color" :class="borderColor"></div>
            <div class="d-flex justify-content-between">
                <a class="expander collapsed d-flex justify-content-between align-items-center" data-toggle="collapse" style="width: 100%"
                   :href="'#dashboard-section-collapse'+id" role="button" aria-expanded="true"
                   :aria-controls="'dashboard-section-collapse'+id">
                    <span class="title-dashboard">
                        <slot name="title"></slot>
                    </span>
                    <img class="collapse-icon" src="images/svg-icons/marlms-chevron.svg" alt="">
                </a>
            </div>
            <div class="collapse inner-card-section-collapsible"
                 :class="{'collapse show' : !startClosed}"
                 :id="'dashboard-section-collapse'+id">
                <div class="dashboard-card-content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "DashboardBox",
    props: {
        'id': {
            type: Number,
            required: true,
        },
        startClosed: {
            type: Boolean,
            default: false,
        },
        borderColor: {
            type: String,
            default: 'red',
        }
    },
};
</script>

<style scoped>

.card {
    padding: 15px 15px 15px 15px;
}

.title-dashboard {
    font-size: 1.1rem;
    font-weight: 700;
    line-height: 1.7rem;
}

.collapse-icon {
    width: 17px;
    height: 17px;
    transition: all 0.3s ease-in-out;
}

.expander {
    margin-right: 0.2rem;
}

.expander[aria-expanded="true"] .collapse-icon {
    transform: rotate(180deg);
}
.expander[aria-expanded="false"] .collapse-icon {
    transform: rotate(0);
}

.dashboard-card-content {
    width: 100%;
    box-shadow: none;
    background: white;
}

</style>
